import { Api } from "../../../../services/interceptor";
import { QUERY_KEY } from "../../../../services/queryEndPoint";
import { appendTournamentFields, buildUpdateTournamentFields } from "./tournamentPayload";

/**
 * PUT /updateTournament — multipart/form-data (same style as updateLeague):
 * scalar fields as named parts + optional `bannerUri` / `logoUri` files.
 * Omitting a file keeps the existing image; `removeBannerImage` /
 * `removeLogoImage` in the draft clear it. No JSON on the query string.
 */
export async function updateTournamentRequest(args: {
  tournamentId: string;
  leagueId: string | null;
  draft: Record<string, unknown>;
  bannerFile?: File | null;
  logoFile?: File | null;
}): Promise<void> {
  const fields = buildUpdateTournamentFields(args.draft, args.tournamentId, args.leagueId);
  const formData = new FormData();
  appendTournamentFields(formData, fields);
  if (args.bannerFile) {
    formData.append("bannerUri", args.bannerFile);
  }
  if (args.logoFile) {
    formData.append("logoUri", args.logoFile);
  }

  await Api.put(QUERY_KEY.updateTournament, formData);
}
